// Generated file : do not modify
import PlageCreneau from '@/extend/classes/PlageCreneau';
import { ListFilter } from '@/extend/classes/ListData';
import ListData from '@/extend/classes/ListData';
import { NotifDefTypes } from '@/generated/classes/NotifDef';
import { storeSession } from '@/generated/stores';
import { type AxiosResponse } from 'axios';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Creneaux
export default class Creneau  {
  // Identifiant unique
  public id: number;
  // Id contrat
  public contratId: number;
  // Date
  public date: Date;
  // Début
  public heureDebut: string | null;
  // Fin
  public heureFin: string | null;
  // Type d'activité
  public activiteId: number;
  // Id lieu
  public lieuId: number;
  // Couleur de l'activite pour la frise
  public color: string;
  // Plages Creneau
  public plages: PlageCreneau[];
  // GUID de création du store
  public createId: string;
  // Commande non exécutée
  public failed: boolean;
  // Donnée pouvant être  modifiée
  public canUpdate: boolean;
  // Donnée pouvant être supprimée
  public canDelete: boolean;
  // Display des objets
  public display: string;
  // Client
  public clientId: number;
  // Type de notification
  public notifDefType: NotifDefTypes;

  constructor() {
    this.id = 0;
    this.contratId = 0;
    this.date = new Date(1901,1,1,0,0,0,0);
    this.heureDebut = null;
    this.heureFin = null;
    this.activiteId = 0;
    this.lieuId = 0;
    this.color = '';
    this.plages = [];
    this.createId = '';
    this.failed = false;
    this.canUpdate = true;
    this.canDelete = true;
    this.display = '';
    this.clientId = 0;
    this.notifDefType = NotifDefTypes.NONE;
  }

  public static fromJson (obj: Creneau): Creneau {
    const newCreneau: Creneau = new Creneau();
    newCreneau.id = obj.id;
    newCreneau.contratId = obj.contratId;
    newCreneau.date = new Date(obj.date);
    newCreneau.heureDebut = obj.heureDebut;
    newCreneau.heureFin = obj.heureFin;
    newCreneau.activiteId = obj.activiteId;
    newCreneau.lieuId = obj.lieuId;
    newCreneau.color = obj.color;
    newCreneau.plages = JSON.parse(JSON.stringify(obj.plages));
    newCreneau.createId = obj.createId;
    newCreneau.failed = obj.failed;
    newCreneau.canUpdate = obj.canUpdate;
    newCreneau.canDelete = obj.canDelete;
    newCreneau.display = obj.display;
    newCreneau.clientId = obj.clientId;
    newCreneau.notifDefType = obj.notifDefType;
    return newCreneau;
  }

  public toJsonCreneau (): string {
    const json = {
      contratId: this.contratId,
      date: this.date ? new Date (this.date).toString() : this.date,
      heureDebut: this.heureDebut,
      heureFin: this.heureFin,
      activiteId: this.activiteId,
      lieuId: this.lieuId,
      color: this.color,
      plages: this.plages,
      canUpdate: this.canUpdate,
      canDelete: this.canDelete,
      notifDefType: this.notifDefType,
    }
    return JSON.stringify(json);
  }

  public fromCreneau (obj: Creneau): void {
    this.id = obj.id;
    this.contratId = obj.contratId;
    this.date = new Date(obj.date);
    this.heureDebut = obj.heureDebut;
    this.heureFin = obj.heureFin;
    this.activiteId = obj.activiteId;
    this.lieuId = obj.lieuId;
    this.color = obj.color;
    this.plages = obj.plages;
    this.createId = obj.createId;
    this.failed = obj.failed;
    this.canUpdate = obj.canUpdate;
    this.canDelete = obj.canDelete;
    this.display = obj.display;
    this.clientId = obj.clientId;
    this.notifDefType = obj.notifDefType;
  }

  public compareCreneau (value: Creneau): boolean {
    return (this.toJsonCreneau() == value.toJsonCreneau());
  }

  public cloneCreneau (): Creneau {
    return Creneau.fromJson(this);
  }

  public createForStoreCreneau (): Promise<Creneau> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/creneaux/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromCreneau(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public updateForStoreCreneau (): Promise<Creneau> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.put('api/creneaux/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromCreneau(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public deleteForStoreCreneau (): Promise<void> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.delete('api/creneaux/' + this.id, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve();
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static list (filter: ListFilter): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/creneaux/list', filter, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static updateCreneaux (creneaux: Creneau[]): Promise<Creneau[]> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/creneaux/updateCreneaux', creneaux, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const cData: Creneau[] = [];
              res.data.forEach(( a: Creneau ) => {
                cData.push(Creneau.fromJson(a));
              })
              resolve(cData);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static getForStore (id: number): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/Creneaux/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              listData.reccords[0] = Creneau.fromJson(listData.reccords[0] as Creneau);
              resolve(listData);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static get (id: number): Promise<Creneau> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/Creneaux/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              const data = Creneau.fromJson(listData.reccords[0] as Creneau);
              resolve(data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static getDate(creneaus: Creneau[]) {
    creneaus.forEach((item) => {
      item.date = item.date ? new Date(item.date) : item.date;
    })
  }
}
